export const clinic = {
  name: "わかば接骨院",
  domain: "https://wakabaseto.jp",
  phone: "0561-83-3833",
  phoneHref: "tel:0561833833",
  postalCode: "489-0809",
  address: "愛知県瀬戸市共栄通3-5",
  fullAddress: "〒489-0809 愛知県瀬戸市共栄通3-5",
  station: "名鉄瀬戸線 新瀬戸駅から徒歩10分",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=%E6%84%9B%E7%9F%A5%E7%9C%8C%E7%80%AC%E6%88%B8%E5%B8%82%E5%85%B1%E6%A0%84%E9%80%9A3-5",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=%E6%84%9B%E7%9F%A5%E7%9C%8C%E7%80%AC%E6%88%B8%E5%B8%82%E5%85%B1%E6%A0%84%E9%80%9A3-5&output=embed",
  hours: {
    morning: "午前9時から12時",
    afternoon: "午後4時から8時",
    shortDays: "水曜・土曜は午前のみ",
    closed: "日曜・祝日は休診",
  },
} as const;

export const openingHoursSpecification = [
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Thursday", "Friday"],
    opens: "09:00",
    closes: "12:00",
  },
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Thursday", "Friday"],
    opens: "16:00",
    closes: "20:00",
  },
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Wednesday", "Saturday"],
    opens: "09:00",
    closes: "12:00",
  },
] as const;
